import * as React from 'react';
import { css } from 'aphrodite';
import { Button, CounterBadge } from '@sharefiledev/flow-web';
import { t } from '../../util';
import { StyledFileListInfo, styles } from './FileListInfo.styles';
export function FileListInfo(props) {
  return /*#__PURE__*/React.createElement(StyledFileListInfo, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: css(styles.fileCount)
  }, /*#__PURE__*/React.createElement(CounterBadge, null, props.fileCount)), props.fileCount > 1 ? t('citrix-files-ui:upload.more_than_one_item_selected') : t('citrix-files-ui:upload.items_selected', {
    count: props.fileCount
  }), props.removeAll && /*#__PURE__*/React.createElement("span", {
    className: css(styles.clearAll)
  }, /*#__PURE__*/React.createElement(Button.TextSecondary, {
    onClick: props.removeAll
  }, t('citrix-files-ui:upload.clear_all'))), props.addMore && /*#__PURE__*/React.createElement("span", {
    className: css(styles.addMore)
  }, /*#__PURE__*/React.createElement(Button.TextPrimary, {
    className: css(styles.addMoreButton),
    onClick: props.addMore
  }, t('citrix-files-ui:upload.add_more')))), props.children);
}